import { tryGet, tryPost, tryPut, tryDelete } from './index';

export const getAllFlowDevices = async () => {
  const result = await tryGet('/flowDevices');
  return result.data;
};

export const getFlowDevice = async (flowDeviceId) => {
  const result = await tryGet(`/flowDevices/${flowDeviceId}`);
  return result.data;
};

export const updateFlowDevice = async (flowDevice) => {
  const result = await tryPut('/flowDevices', flowDevice);
  return result.data;
};

export const addFlowDevice = async (flowDevice) => {
  const result = await tryPost('/flowDevices', flowDevice);
  return result.data;
};

export const deleteFlowDevice = async (flowDeviceId) => {
  const result = await tryDelete(`/flowDevices/${flowDeviceId}`);
  return result.data;
};
